import { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { FileText, ChevronDown, ChevronUp, RotateCcw } from "lucide-react";

export default function TextsCard() {
  const [d, setD] = useState(null);
  const [vals, setVals] = useState({});
  const [open, setOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/settings/texts").then((r) => { setD(r.data); setVals(r.data.values); }).catch(() => {}); }, []);
  if (!d) return null;
  const dirty = d.fields.some((f) => (vals[f.key] || "") !== (d.values[f.key] || ""));
  const save = async () => {
    setSaving(true);
    try { const { data } = await api.put("/settings/texts", { values: vals }); setD({ ...d, values: data.values }); setVals(data.values); toast.success("Texty uloženy – platí ihned pro e-maily, SMS, letáky i průvodce"); }
    catch (e) { toast.error(apiErr(e)); } finally { setSaving(false); }
  };
  return (
    <div className="bg-white rounded-xl border p-5 space-y-3" data-testid="texts-card">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between" data-testid="texts-toggle">
        <h3 className="font-semibold text-[#0A2540] flex items-center gap-2"><FileText className="h-4 w-4" /> Texty systému (pokyny, SMS, hlášky)</h3>
        {open ? <ChevronUp className="h-4 w-4 text-slate-400" /> : <ChevronDown className="h-4 w-4 text-slate-400" />}
      </button>
      {!open && <p className="text-sm text-slate-500">Servisní tým: <b>{d.values.service_contact}</b> · Upravte výchozí pokyny, texty SMS a hlášky pro obyvatele. Vlastní texty jednotlivých akcí (pokyny, leták) mají přednost.</p>}
      {open && (
        <div className="space-y-4" data-testid="texts-form">
          {d.fields.map((f) => (
            <div key={f.key} className="space-y-1">
              <div className="flex items-center justify-between gap-2">
                <Label className="text-sm">{f.label}</Label>
                {(vals[f.key] || "") !== d.defaults[f.key] && (
                  <button onClick={() => setVals({ ...vals, [f.key]: d.defaults[f.key] })} className="text-xs text-slate-500 hover:text-[#0A2540] inline-flex items-center gap-1" data-testid={`texts-reset-${f.key}`}><RotateCcw className="h-3 w-3" /> výchozí</button>
                )}
              </div>
              {f.rows === 1
                ? <Input value={vals[f.key] || ""} onChange={(e) => setVals({ ...vals, [f.key]: e.target.value })} data-testid={`texts-input-${f.key}`} />
                : <Textarea rows={f.rows} value={vals[f.key] || ""} onChange={(e) => setVals({ ...vals, [f.key]: e.target.value })} data-testid={`texts-input-${f.key}`} />}
              <p className="text-xs text-slate-500">{f.help}{f.key.startsWith("sms_") && <span className="ml-1 text-slate-400">({(vals[f.key] || "").length} znaků)</span>}</p>
            </div>
          ))}
          <div className="flex gap-2">
            <Button onClick={save} disabled={!dirty || saving} style={{ background: "#0A2540" }} data-testid="texts-save">Uložit texty</Button>
            <Button variant="outline" onClick={() => setVals(d.values)} disabled={!dirty} data-testid="texts-discard">Zahodit změny</Button>
          </div>
        </div>
      )}
    </div>
  );
}
